
import Wrapper from '../assets/wrappers/LandingPage'
import HowItWorks from '../components/HowItWorks'
import LoginForm from '../components/LoginForm'
import SabhaCarousel from '../components/SabhaCarousel'
import SabhaSaarHeader from '../components/SabhaSaarHeader'
import TopHeader from '../components/TopHeader'
import WelcomeBox from '../components/WelcomeBox'
import FileTXT from "../assets/images/icons/file-text-dynamic-color.png";
import Folder from "../assets/images/icons/folder-dynamic-color.png"
import SiteSlider from '../components/SiteSlider'
import Footer from '../components/Footer'
import DashboardHome from '../components/DashboardHome'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setSelectedFinYear } from '../features/common/commonSlice'
import SabhaSaarHeaderPublic from '../components/SabhaSaarHeaderPublic'

const userManualPDF = '/resources/User_Manual.pdf';
const sopPDF = '/resources/Standard_Operating_Procedure.pdf';

const LandingPage: React.FC = () => {
  const dispatch = useDispatch();
  const handleDownload = (fileUrl: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  };
  useEffect(()=>{
     dispatch(setSelectedFinYear(""))
  })

  return (
    <Wrapper>
      <TopHeader />
      <section className="body-content">
        <div className="row box-shadow1">
          <SabhaSaarHeaderPublic />
        </div>
        <SabhaCarousel />
        <div className="row mt-3" id='homeMainContent'>
          <div className="col-12 col-md-8 mb-3" style={{paddingLeft : '0'}}>
            <div className="welcome-box box-shadow1 p-3 h-100">
              <WelcomeBox />
            </div>
          </div>

          <div className="col-12 col-md-4 mb-3" style={{paddingLeft : '0'}}>
            <div className="login-form-container box-shadow1 p-3 h-100">
              <LoginForm />
            </div>
          </div>
        </div>
        <DashboardHome/>
        <HowItWorks />
        <div className="row grid-temp2 mt-3">
        <div className="box-shadow1" onClick={() => handleDownload(userManualPDF, 'User_Manual.pdf')}>
          <div className="resource-container">
            <img src={FileTXT} alt="" />
            <span>User Manual</span>
          </div>
        </div>

        <div className="box-shadow1" onClick={() => handleDownload(sopPDF, 'Standard_Operating_Procedure.pdf')}>
          <div className="resource-container">
            <img src={Folder} alt="" />
            <span>Standard Operating Procedure</span>
          </div>
        </div>
      </div>
      </section>
      <SiteSlider />
      <Footer />
    </Wrapper>
  )
}

export default LandingPage  